import * as THREE from "three" 
import { CSS3DRenderer } from 'three/examples/jsm/renderers/CSS3DRenderer.js';
import Sizes from "./Utils/Sizes.js"
import Time from "./Utils/Time.js"
import Camera from "./Camera.js"
import Renderer from "./Renderer.js"
import World from "./World/World.js"
import Resources from "./Utils/Resources.js"
import Debug from "./Utils/Debug.js"
import sources from './sources.js'


let instance = null

export default class Experience{
    constructor(canvas){

        if(instance){
            return instance
        }

        instance = this
        window.experience = this
        this.canvas = canvas
        
        this.debug = new Debug()
        this.sizes = new Sizes() 
        this.time = new Time()
        this.scene = new THREE.Scene()
        this.cssScene = new THREE.Scene(); // Egen scene for HTML i 3D
        this.cssRenderer = new CSS3DRenderer();
        this.cssRenderer.setSize(this.sizes.width, this.sizes.height);
        this.cssRenderer.domElement.style.position = 'absolute';
        this.cssRenderer.domElement.style.top = '0';
        this.cssRenderer.domElement.style.pointerEvents = 'none'; // kan overstyres i objektet
        document.body.appendChild(this.cssRenderer.domElement);
        this.resources = new Resources(sources)
        this.camera = new Camera()
        this.renderer = new Renderer()
        this.world = new World()

        this.sizes.on('resize', ()=>{
            this.resize()
        })

        this.time.on('tick', ()=>{
            this.update()
        })
    }
    resize(){
        this.camera.resize()
        this.renderer.resize()
    }

    update(){
        this.camera.update()
        this.world.update()
        this.renderer.update()
        this.cssRenderer.render(this.cssScene, this.camera.instance);
    }  

    destroy(){
        this.sizes.off('resize')
        this.time.off('tick')

        this.scene.traverse((child) => {
            if (child instanceof THREE.Mesh) {
              child.geometry.dispose();
      
              for (const key in child.material) {
                const value = child.material[key];
                if (value && value.dispose === "function") {
                  value.dispose();
                }
              }
            }
          });
          this.camera.controls.dispose();
          this.renderer.instance.dispose();
      
          if (this.debug.active) {
            this.debug.ui.destroy();
          }
    }
}